<template>
  <div class="irp-data-source-cell">
    <template v-if="firstDataSource">
      <span class="irp-data-source-cell__source">
        <BittsSvg
          :svg="`${firstDataSource.integrationType}Icon`"
          class="irp-data-source-cell__icon"
        />
        <span class="irp-data-source-cell__label">
          {{ firstDataSource.label }}
        </span>
      </span>
      <BittsPopover
        v-if="overflowDataSources.length"
        trigger="hover"
        placement="bottomLeft"
        :mount-to-body="true"
      >
        <span class="irp-data-source-cell__overflow">
          +{{ overflowDataSources.length }}
        </span>
        <template #content>
          <div class="irp-data-source-cell__list">
            <span
              v-for="dataSource in overflowDataSources"
              :key="dataSource.integrationType"
              class="irp-data-source-cell__source"
            >
              <BittsSvg
                :svg="`${dataSource.integrationType}Icon`"
                class="irp-data-source-cell__icon"
              />
              <span class="irp-data-source-cell__label">
                {{ dataSource.label }}
              </span>
            </span>
          </div>
        </template>
      </BittsPopover>
    </template>
    <span v-else class="irp-data-source-cell__empty">&mdash;</span>
  </div>
</template>

<script setup lang="ts">
import { BittsPopover, BittsSvg } from '@crossbeam/bitts';

import type { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

import { DataSourceFriendlyName } from '@/constants/data_sources';
import type { RecordOverviewPartnerType } from '@/types/individual_record';

const { params } = defineProps<{
  params: ICellRendererParams<RecordOverviewPartnerType>;
}>();

const dataSources = computed(() => {
  const integrationTypes = params.data?.data_sources ?? [];
  return [...new Set(integrationTypes)].map((integrationType) => ({
    integrationType,
    label: DataSourceFriendlyName[integrationType] || integrationType,
  }));
});

const firstDataSource = computed(() => dataSources.value[0]);
const overflowDataSources = computed(() => dataSources.value.slice(1));
</script>

<style lang="pcss">
@reference "../../../css/theme.css";
.irp-data-source-cell {
  @apply flex items-center gap-4 h-full w-full text-neutral-text;
}

.irp-data-source-cell__source {
  @apply flex items-center gap-8 min-w-0;
}

.irp-data-source-cell__icon {
  @apply h-16 w-16 shrink-0;
}

.irp-data-source-cell__label {
  @apply truncate text-sm;
}

.irp-data-source-cell__overflow {
  @apply shrink-0 cursor-default text-sm text-neutral-text-weak;
}

.irp-data-source-cell__list {
  @apply flex flex-col items-start gap-4 p-8;
}

.irp-data-source-cell__empty {
  @apply text-neutral-text-weak;
}
</style>
